







    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import toolstripItem from './toolstripItem.vue'
    export default Vue.extend({
        name: 'c-toolstrip',
        components: { 'toolstrip-item':toolstripItem },
        data() {
            return {};
        },
        computed: {
            haveItems(): boolean {
                return this.$store.state.ui.toolstripItems != null && this.$store.state.ui.toolstripItems.length > 0;
            }

        }
    });
